import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLink from "@/pages/PublicLink";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLinks from "@/pages/AdminLinks";
import LinkDetail from "@/pages/LinkDetail";
import Support from "@/pages/Support";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicLink />} />
        <Route path="/download" element={<PublicLink />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/links" element={<AdminLinks />} />
        <Route path="/admin/links/:slug" element={<LinkDetail />} />
        <Route path="/:slug" element={<PublicLink />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
